angular.module('st')
    .controller('customerRefundsController', [
        '$rootScope', '$scope', '$http',
        function ($rootScope, $scope, $http) {
            var ctrl = this;
            $scope.isError = false;
            $scope.isSettlementPending = false;
            $scope.feedback = '';
            $scope.processing = false;
            $scope.refundSubmitted = false;
            $scope.confirmationCode = null;
            $scope.isMidtownWebsite = false;
            $scope.loyaltyVouchers = []; 

            var getParameterByName = function (name) {
                var url = window.location.href;
                name = name.replace(/[\[\]]/g, '\\$&');
                var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
                    results = regex.exec(url);

                if (!results) return null;
                if (!results[2]) return null;

                return decodeURIComponent(results[2].replace(/\+/g, ' '));
            }

            // Braintree sale not settled yet (Vista.API BookingService.RefundSettlementPendingKey).
            // Lets the view swap its generic red help text for settlement-specific text so the
            // customer doesn't get two conflicting timeframes (24 hours vs 1 hour).
            var SETTLEMENT_PENDING_KEY = 'RefundSettlementPending';
            var hasSettlementPendingFlag = function (responseData) {
                var msgs = (responseData && responseData.ValidationMessages) || [];
                for (var i = 0; i < msgs.length; i++) {
                    if (msgs[i] && msgs[i].Key === SETTLEMENT_PENDING_KEY) return true;
                }
                return false;
            };

            ctrl.TicketsThatAreNotRefunded = function (seats) {
                if (!seats) { return; }
                var filteredSeats = seats.filter(function (el) {
                    return el.RefundedStatus !== "1";
                });
                return filteredSeats ? filteredSeats.length : 0;
            }

            ctrl.IsFieldInvalid = function (field) {
                return field.$invalid && (field.$touched || $scope.frm.$submitted);
            }

            var clear = function () {
                $scope.bookingData = null;
                $scope.refundSubmitted = false;
                $scope.feedback = null;
                $scope.isError = false;
                $scope.isSettlementPending = false;
            };

            ctrl.loadBooking = function () {
                if ($scope.processing == false) {
                    clear();
                    $scope.processing = true;
                    $scope.feedback = 'Loading booking data...';

                    grecaptcha.ready(function () {
                        grecaptcha.execute($('#captcha-site-key').val(), { action: 'crewards_customer_refund' }).then(function (token) {
                            //console.log('captcha key', $('#captcha-site-key').val());
                            //console.log('token', token);
                            //token = encodeURI(token);
                            //token = encodeURIComponent(token);
                            //var url = $scope.isMidtownWebsite ? "/rpc/order/booking/" + $scope.confirmationCode + "/" + token + "/true" : "/rpc/order/booking/" + $scope.confirmationCode + "/" + token;
                            var url = "/rpc/order/booking";
                          
                            var config = {
                                bookingId: $scope.confirmationCode,
                                token: token,
                                isMidtownWebsite: $scope.isMidtownWebsite ? true : false,
                                archivable: true
                            };

                            $http.post(url, config)
                                .then(function (d) {
                                    if (d.data.Success == true) {
                                        $scope.bookingData = d.data.Data;
                                        $scope.feedback = '';
                                    } else {
                                        // vista error 
                                        $scope.feedback = 'Error: ' + d.data.Message;
                                        $scope.isError = true;
                                    }
                                    $scope.processing = false;
                                }).catch(function (error) {
                                    console.log(arguments);
                                    // our server error 
                                    $scope.processing = false;
                                    $scope.feedback = 'Error occurred while trying to submit the refund.';
                                    $scope.isError = true;
                                });
                        });
                    });
                }
            };

            ctrl.cancel = function () {
                clear();
            };

            ctrl.ProcessRefund = function () {
                if ($scope.processing == false) {
                    $scope.isError = false;
                    $scope.isSettlementPending = false;
                    $scope.processing = true;
                    $scope.feedback = 'Processing refund...';

                    var url = $scope.isMidtownWebsite ? "/rpc/order/refund/" + $scope.bookingData.BookingId + "/true" : "/rpc/order/refund/" + $scope.bookingData.BookingId;

                    $http.post(url)
                        .then(function (data) {
                            if (data.data.Success == true) {
                                $scope.feedback = 'Success! Your refund will start processing after about 5 minutes.';
                                $scope.processing = false;
                                $scope.refundSubmitted = true;
                            } else {
                                // vista error 
                                $scope.processing = false;
                                $scope.feedback = 'Error: ' + data.data.Message;
                                $scope.isError = true;
                                $scope.isSettlementPending = hasSettlementPendingFlag(data.data);
                            }
                        }).catch(function (error) {
                            // our server error 
                            $scope.processing = false;
                            $scope.feedback = 'Error occurred while trying to submit the refund.';
                            $scope.isError = true;
                        });
                }
            };

            var init = function () {
                $scope.confirmationCode = getParameterByName('confirmationCode');
                // "isMidtownWebsite" really means "refund booking fees too" (full refund).
                // Primary signal is the widget checkbox, rendered into #refund-with-booking-fee.
                // This is stable across URL changes, so the privacy URL can be rotated freely.
                // The midtown + legacy URL substring checks are kept as fallbacks so existing
                // Midtown and /refund-with-booking-fee pages keep working unchanged.
                var refundBookingFeeFlag = ($('#refund-with-booking-fee').val() || '').toLowerCase() === 'true';
                $scope.isMidtownWebsite = refundBookingFeeFlag
                    || window.location.href.toLowerCase().includes("midtown")
                    || window.location.href.toLowerCase().includes("refund-with-booking-fee");
                if ($scope.confirmationCode) ctrl.loadBooking();
            };

            init();
        }
    ]);
